interface ResetButtonProps {
  onReset: () => void;
  isEnabled?: boolean;
}

export function ResetButton({ onReset, isEnabled = true }: ResetButtonProps) {
  return (
    <button
      onClick={onReset}
      type="button"
      disabled={!isEnabled}
      className={`
        px-3 py-1.5 text-xs border border-border bg-card rounded-md font-medium
        transition-all duration-150 flex items-center gap-1
        ${
          isEnabled
            ? 'text-text-light cursor-pointer hover:border-text hover:bg-bg'
            : 'text-border cursor-not-allowed'
        }
      `}
      title="Reset to original state"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 8C2 4.68629 4.68629 2 8 2C9.5 2 10.8 2.6 11.8 3.5M14 8C14 11.3137 11.3137 14 8 14C6.5 14 5.2 13.4 4.2 12.5M11.8 3.5V1M11.8 3.5H9.5M4.2 12.5V15M4.2 12.5H6.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      Reset
    </button>
  );
}
